import { render } from "./TheHero.vue?vue&type=template&id=61b31fc2&scoped=true"
import script from "./TheHero.vue?vue&type=script&lang=js"
export * from "./TheHero.vue?vue&type=script&lang=js"

import "./TheHero.vue?vue&type=style&index=0&id=61b31fc2&scoped=true&lang=css"

import exportComponent from "D:\\Learning\\Projects\\allankirui.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b31fc2"]])

export default __exports__